import { useEffect, useState } from "react";
import {useDataFetch} from "../useDataFetch";


const useCities = () => {
    const [state] = useDataFetch({method: 'GET', url: '/cities'});
    const [locations, setLocations] = useState([]);
    const [provincesWithCities, setProvincesWithCities] = useState([]);
    
    useEffect(() => {
        if(!state.isLoading && !state.isError && state.data){
            const list = [];
            let value = state?.data?.payload;
            setLocations(value);
            for (let i = 0; i < value.length; i++) {
                for (let j = 0; j < value[i].cities.length; j++) {
                    list.push({
                        name: `${value[i].name} - ${value[i].cities[j].name}`,
                        title: `${value[i].name} - ${value[i].cities[j].name}`,
                        _id: value[i].cities[j].id,
                        code: value[i].cities[j].code,
                        default: false,
                    });
                }
            }
            setProvincesWithCities(list);
        }
    }, [state])
   
    return [provincesWithCities, locations, state?.isLoading];
}
export default useCities;